"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var _1 = require(".");
var CheckboxList = function (_a) {
    var filters = _a.filters, onChange = _a.onChange;
    return ((0, jsx_runtime_1.jsx)(material_1.FormGroup, { children: Object.entries(filters).map(function (_a) {
            var key = _a[0], value = _a[1];
            return ((0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { name: key, control: (0, jsx_runtime_1.jsx)(_1.ThemedCheckbox, { onChange: function (e) { return onChange(e, value.label); } }), checked: value.isChecked, label: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "bodyMedium", sx: {
                        color: value.isChecked ? 'primary.600' : 'primary.400',
                        paddingTop: '0.3rem',
                    } }, { children: value.label })) }, key));
        }) }));
};
exports.CheckboxList = CheckboxList;
